/**
 * Organic “cell membrane” motion: asymmetric squash/stretch + phase drift (visual only).
 */

/** Advance membrane phase with irregular rhythm (flows like cytoskeleton tug). */
export function advanceMembranePhase(phase, dt, speedMul = 1) {
  return phase + dt * (3.35 + 1.15 * Math.sin(phase * 0.41)) * speedMul;
}

/** Scale factors for pseudo-amoeboid deformation (combine with unequal axes). */
export function membraneScaleXY(phase, ampPrimary = 0.11, ampSecondary = 0.046) {
  const sx =
    1 +
    ampPrimary * Math.sin(phase) +
    ampSecondary * Math.sin(phase * 2.13);
  const sy =
    1 -
    ampPrimary * 0.78 * Math.sin(phase * 1.09) +
    ampSecondary * Math.cos(phase * 1.67);
  return { sx, sy };
}

/** Gentle twist — reads like membrane shear helping glide (visual only). */
export function wbcMembraneRotation(phase, seekMul = 1) {
  return 0.075 * Math.sin(phase * 0.68 + seekMul * 3.7);
}
